import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import ProjectDetail from './pages/ProjectDetail';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import JazzCashSolution from './pages/JazzCashSolution';
import AIVoiceSolution from './pages/AIVoiceSolution';
import Products from './pages/Products';
import ShopifyPaymentCustomization from './pages/ShopifyPaymentCustomization';
import ProductWidget from './pages/ProductWidget';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <Navbar />
        <div className="page-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:id" element={<ProjectDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/jazzcash-payment-gateway-integration" element={<JazzCashSolution />} />
            <Route path="/solutions/ai-voice-automation" element={<AIVoiceSolution />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/shopify-payment-customization" element={<ShopifyPaymentCustomization />} />
            <Route path="/products/product-widget" element={<ProductWidget />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
